<script>
import formMixin from '@/mixins/formMixin'
import baseMixin from '@/mixins/baseMixin'
// eslint-disable-next-line no-unused-vars
import SubBubbleAgreementDiscountViewModel from '@/models/subBubbleAgreement/subBubbleAgreementDiscountViewModel'
// eslint-disable-next-line no-unused-vars
import ClientPayClassClassificationViewModel from '@/models/client/clientPayClassClassificationViewModel'

export default {
  name: 'SubBubbleAgreementEditorDiscountRow',
  mixins: [baseMixin, formMixin],
  props: {
    /**
     * @type {SubBubbleAgreementDiscountViewModel}
     */
    value: {
      type: Object,
      required: true,
    },
    /**
     * @type {ClientPayClassClassificationViewModel[]}
     */
    classifications: {
      type: Array,
      required: true,
    },
    classificationIdsInUse: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      classificationId: this.value.classificationId,
      candidateCount: this.value.candidateCount,
      discount: this.value.value,
      rules: {},
    }
  },
  computed: {
    showDeleteBtn() {
      return this.multipleDiscountsInUse
    },
    multipleDiscountsInUse() {
      return this.classificationIdsInUse.length > 1
    },
    availableClassifications() {
      return this.classifications.filter(
        (c) =>
          c.classificationId === this.value.classificationId ||
          !this.classificationIdsInUse.includes(c.classificationId)
      )
    },
  },
  watch: {
    classificationId(newVal) {
      this.$emit('input', { ...this.value, classificationId: newVal })
    },
    candidateCount(newVal) {
      this.$emit('input', { ...this.value, candidateCount: Number(newVal) })
    },
    discount(newVal) {
      this.$emit('input', { ...this.value, value: Number(newVal) })
    },
  },
  created() {
    this.initValidationRules()
  },
  methods: {
    initValidationRules() {
      this.rules = {
        ...this.rules,
        classificationRequired: (v) =>
          !this.multipleDiscountsInUse ||
          !!v ||
          this.$t('input.inputRequiredValidationText'),
      }
    },
  },
}
</script>

<template>
  <v-row dense>
    <v-col cols="4">
      <v-select
        v-model="classificationId"
        data-testid="classification-select"
        :items="availableClassifications"
        item-text="classification"
        item-value="classificationId"
        placeholder="Classification"
        persistent-placeholder
        :rules="[rules.classificationRequired]"
      ></v-select>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="candidateCount"
        data-testid="candidate-count"
        type="number"
        label="Candidate Count"
        prepend-icon="mdi-account-group"
        :rules="[rules.positiveNumber, rules.validInt32]"
      ></v-text-field>
    </v-col>
    <v-col cols="3">
      <v-text-field
        v-model="discount"
        data-testid="discount-value"
        type="number"
        label="Discount"
        append-icon="mdi-percent"
        :rules="[rules.required, rules.validPercent]"
      ></v-text-field>
    </v-col>
    <v-col
      v-if="showDeleteBtn"
      cols="1"
      class="d-flex justify-center align-center"
    >
      <v-btn icon class="delete-btn" @click="$emit('on-delete')">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>
